<div class="page-content min-h-100" [ngStyle]="{display: 'flex', 'flex-direction': 'column', height: '100%'}">
    <p-panel
        [header]="organization ? 'Organization : ' + organization.name : '...'"
        [ngStyle]="{display: 'flex', 'flex-direction': 'column', 'flex-grow': '1', 'min-height': '0'}"
    >
        @if (showLoading) {
            <div class="text-center">
                <p-progressSpinner
                    styleClass="w-4rem h-4rem"
                    strokeWidth="4"
                    animationDuration="1.5s"
                ></p-progressSpinner>
                <div class="mt-2 mb-2">{{ loadingStr }}</div>
            </div>
        } @else {
            <p-tabs [(value)]="currentTab">
                <p-tablist>
                    <p-tab [value]="EOrganizationTab.GENERAL" ariaLabel="General information tab">Overview</p-tab>
                    <p-tab [value]="EOrganizationTab.SERVICE_REQUESTS" ariaLabel="Service requests tab"
                        >Service Requests</p-tab
                    >
                    <p-tab [value]="EOrganizationTab.HIERARCHY" ariaLabel="Locations tab">Locations</p-tab>
                    <p-tab [value]="EOrganizationTab.OBJECT_STORE" ariaLabel="Object store tab">Object Store</p-tab>
                    <p-tab [value]="EOrganizationTab.FILES" ariaLabel="Files tab">Files</p-tab>
                </p-tablist>

                <p-tabpanels> </p-tabpanels>
            </p-tabs>

            <div [ngStyle]="{display: 'flex', 'flex-direction': 'column', 'flex-grow': '1', 'min-height': '0'}">
                @switch (currentTab) {
                    @case (EOrganizationTab.GENERAL) {
                        @if (organization) {
                            <app-organization-general-info
                                [organization]="organization"
                                [refreshTrigger$]="refreshStatistics$.asObservable()"
                                (organizationUpdated)="onOrganizationUpdated()"
                                [ngStyle]="{display: 'block', height: '100%'}"
                            ></app-organization-general-info>
                        } @else {
                            <div class="mb-4 mt-4 text-center"><b>Organization not found!</b></div>
                        }
                    }
                    @case (EOrganizationTab.SERVICE_REQUESTS) {
                        @if (organization) {
                            <app-service-request-crud
                                [showOrganization]="false"
                                [organizationUUID]="organization.uuid"
                                (serviceRequestChanged)="refreshStatistics$.next()"
                            ></app-service-request-crud>
                        } @else {
                            <div class="mb-4 mt-4 text-center"><b>Organization not found!</b></div>
                        }
                    }
                    @case (EOrganizationTab.HIERARCHY) {
                        @if (organization) {
                            <app-organization-hierarchy></app-organization-hierarchy>
                        } @else {
                            <div class="mb-4 mt-4 text-center"><b>Organization not found!</b></div>
                        }
                    }
                    @case (EOrganizationTab.OBJECT_STORE) {
                        @if (organization) {
                            <app-object-store-entry-crud
                                [linkObjectType]="'organization'"
                                [linkObjectUUID]="organization.uuid"
                                (objectStoreChanged)="refreshStatistics$.next()"
                            ></app-object-store-entry-crud>
                        } @else {
                            <div class="mb-4 mt-4 text-center"><b>Organization not found!</b></div>
                        }
                    }
                    @case (EOrganizationTab.FILES) {
                        <!-- Files Panel -->
                        <!-- TODO: Backend modification needed - Add organization_uuid to CpmCCustomerFileEntryApiModel
                         to enable filtering files by organization. Currently shows all customer files. -->
                        @if (organization) {
                            <app-user-file-crud></app-user-file-crud>
                        } @else {
                            <div class="mb-4 mt-4 text-center"><b>Organization not found!</b></div>
                        }
                    }
                }
            </div>
        }
    </p-panel>
</div>
